import { Auth } from 'aws-amplify';
// Internal
import config from 'config/config';
import { getTeamMembers } from 'services/managePractice';

const rndLetter = (len, chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz') => [...Array(len)].map(() => chars.charAt(Math.floor(Math.random() * chars.length))).join('');
const rndNumber = (len, chars = '0123456789') => [...Array(len)].map(() => chars.charAt(Math.floor(Math.random() * chars.length))).join('');
const rndSymbol = (len, chars = '*@!()-_') => [...Array(len)].map(() => chars.charAt(Math.floor(Math.random() * chars.length))).join('');

/**
 * @todo Login for new user
 * @param {Object} cognitoUser a CognitoUser object
 */
export async function loginNewUser(cognitoUser) {
    const newPassword = rndLetter(4) + rndNumber(4) + rndSymbol(2);
    const response = await Auth.completeNewPassword(cognitoUser, newPassword);
    return response;
}

/**
 * @todo Replace the example request for a functional request
 * @param {Object} email Email of the user to login
 * @param {Object} password Password of the user to login
 */
export async function login(email, password) {
    const response = await Auth.signIn(email, password);

    if (!response.signInUserSession) {
        return response;
    }

    await localStorage.setItem(config.TOKEN, response.signInUserSession.accessToken.jwtToken);

    // Sets the test user's data
    const data = {
        email,
        username: email,
        brand: config.BRAND
    };
    // Sets token into the localstorage
    await localStorage.setItem(config.USERDATA, JSON.stringify(data));

    // Gets the vet users and roles to match with the current user
    const membersResponse = await getTeamMembers();
    // If user has no vet it removes the token and data previously stored
    if (!membersResponse.data) {
        localStorage.removeItem(config.TOKEN);
        localStorage.removeItem(config.USERDATA);
        return;
    }

    const user = membersResponse.data.find((member) => {
        return member.cstm.cognito_username_c?.toLowerCase() === email.toLowerCase();
    });

    // If user is not part of the vet it removes the token and data previously stored
    if (!user) {
        localStorage.removeItem(config.TOKEN);
        localStorage.removeItem(config.USERDATA);
        return;
    }

    // Sets the test user's data
    data.role = user.cstm.portal_access_c;
    data.id = user.id;
    // Updates the user data with the role into the localstorage
    localStorage.setItem(config.USERDATA, JSON.stringify(data));
    return response;
}

/**
 * @param {Object} email Email of the user to login
 * @param {Object} password Password of the user to login
 */
export async function guestLogin(email, password) {
    // TODO: change this with guest account
    const response = await Auth.signIn(email, password);
    await sessionStorage.setItem(config.GUEST_TOKEN, response.signInUserSession.accessToken.jwtToken);
}

/**
 * @todo Send the user's email or username?
 * @param {string} email Email of user requesting reset password
 */
export async function sendResetPassword(email) {
    return Auth.forgotPassword(email);
}

/**
 * Request the new password reset after having received the verification code of forgot password
 * @param {string} username
 * @param {string} code The code send to the account's email to verify the account
 * @param {string} newPassword
 */
export async function resetPassword(username, code, newPassword) {
    // Sends the confirmation code and new password
    return Auth.forgotPasswordSubmit(username, code, newPassword);
}

/**
 */
export async function changePassword() {
    // Collect confirmation code and new password, then
    // return Auth.forgotPasswordSubmit(username, code, newPassword);
}

/**
 * Gets the logged in user's role
 */
export function getUserRole() {
    const userDataStr = localStorage.getItem(config.USERDATA);
    if (userDataStr) {
        const userData = JSON.parse(userDataStr);
        return userData.role;
    }
    return null;
}

/**
 * Gets the logged in user's role
 */
export function isOwner() {
    const userRole = getUserRole();
    return !!(userRole && userRole.toLowerCase().includes('owner'));
}

/**
 * Gets the brand of the current user
 */
export function getBrand() {
    const userDataStr = localStorage.getItem(config.USERDATA);
    if (userDataStr) {
        const userData = JSON.parse(userDataStr);
        return userData.brand;
    }
    return null;
}

/**
 * Gets the brand of the current user
 */
export function isLawnswoodBrand() {
    return getBrand() ? getBrand().includes('Lawnswood') : '';
}
